import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import styled from "styled-components";

import {
  BaseFieldStyle,
  FieldWrapper,
  Label,
  RequiredMark,
  ErrorText,
} from "./SharedFormStyles";

const StyledInput = styled.input.withConfig({
  shouldForwardProp: (prop) => prop !== "hasError",
})`
  ${BaseFieldStyle}
`;

const FormInputField = ({
  name,
  label,
  type,
  control,
  error = null,
  placeholder,
  required = false,
  disabled = false,
}) => {
  return (
    <FieldWrapper>
      {label && (
        <Label variant="body1" component="label" htmlFor={name}>
          {label} {required && <RequiredMark>*</RequiredMark>}
        </Label>
      )}

      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <StyledInput
            {...field}
            id={name}
            type={type}
            placeholder={placeholder}
            hasError={!!error}
            disabled={disabled}
          />
        )}
      />

      {error && <ErrorText variant="body2">{error.message}</ErrorText>}
    </FieldWrapper>
  );
};

// PropTypes
FormInputField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.oneOf(["text", "number", "checkbox", "month", "date"]),
  control: PropTypes.object.isRequired,
  error: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default FormInputField;
